import React from "react";
import PropTypes from "prop-types";
import { Field, Form } from "react-final-form";
import ValidatedInput from "../../common/ValidatedInput";
import { useQuery } from "react-query";
import { getCountries } from "../../../queries/organization";
import CustomSelect from "../../common/CustomSelect";

const EditOrganizationForm = ({ onSubmit, organization }) => {
  const {
    isLoading,
    isError,
    data: countries,
  } = useQuery(
    "countries",
    () =>
      getCountries().then((data) => {
        return data;
      }),
    {
      keepPreviousData: true,
    }
  );

  return (
    <div
      id="settings"
      className="tab-pane active pr-lg-5 mr-lg-5 border-lg-right mw-sm-400 mx-auto"
    >
      <h4 className="mb-4">Settings</h4>
      {/*<h5 class="mt-5 mb-4">Billing Information</h5>*/}
      <Form
        onSubmit={onSubmit}
        initialValues={organization}
        render={({
          submitError,
          handleSubmit,
          form,
          submitting,
          pristine,
          values,
        }) => (
          <form onSubmit={handleSubmit}>
            <Field
              label={"Organization name"}
              inputClassName="fin-control"
              name="legalName"
              component={ValidatedInput}
              type="text"
              placeholder="eg verge.capital"
            />
            <Field
              label={"VAT No."}
              inputClassName="fin-control"
              name="vat"
              component={ValidatedInput}
              type="text"
              placeholder="eg IE3585794NH"
              disabled={true}
            />
            <Field
              label={"Address"}
              inputClassName="fin-control"
              name="billingAddress"
              component={ValidatedInput}
              type="text"
              placeholder=""
            />
            <div className="row row-xs">
              <div className="col-7">
                <Field
                  label={"City"}
                  inputClassName="fin-control"
                  name="city"
                  component={ValidatedInput}
                  type="text"
                  placeholder="Athens"
                />
              </div>
              <div className="col-5">
                <Field
                  label={"ZIP Code"}
                  inputClassName="fin-control"
                  name="postalCode"
                  component={ValidatedInput}
                  type="text"
                  placeholder="11147"
                />
              </div>
            </div>
            {countries && !isLoading && !isError && (
              <Field
                label={"Country"}
                options={countries}
                name="country"
                component={CustomSelect}
                placeholder="Country"
                isSearchable={true}
                isMulti={false}
                isClearable={true}
              />
            )}
            <div className="mt-5">
              <button
                disabled={submitting || pristine}
                id="submit"
                className="btn btn-sm btn-main"
              >
                Update settings
              </button>
              <button
                type="button"
                className="btn btn-sm btn-cancel"
                onClick={form.reset}
                disabled={submitting || pristine}
              >
                Reset
              </button>
            </div>
          </form>
        )}
      />
    </div>
  );
};

EditOrganizationForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  organization: PropTypes.object.isRequired,
};

export default EditOrganizationForm;
